<div class="cardActivation">
  <mat-horizontal-stepper #stepper (selectionChange)="updateCurrentStepLabel($event)" linear >
    <mat-step [editable]="editable">
      <ng-template matStepLabel>{{stepperLabels.LOGIN}}</ng-template>
      <app-login id="loginStep" (openFAQ)="openFAQDialog()"></app-login>
    </mat-step>

    <mat-step [editable]="editable">
      <ng-template matStepLabel>{{stepperLabels.TERMS_CONDITIONS}}</ng-template>
      <div class="step-content">
        <button mat-raised-button class="faq-button" (click)="openFAQDialog()">Help and FAQ's</button>
        <app-terms-condition
          id="termsStep"
          [purpose]="'activation'"
          [country]="userLocation ?? 'AU'"
          (termsClick)="openOtpDialog()"></app-terms-condition>
      </div>
    </mat-step>

    <mat-step [editable]="editable" #memberTypeStep>
      <ng-template matStepLabel>{{stepperLabels.MEMBER_TYPE}}</ng-template>
      <div class="step-content">
        <button mat-raised-button class="faq-button" (click)="openFAQDialog()">Help and FAQ's</button>
        <app-member-type
          id="memberTypeStep"
          [isActiveStep]="stepper.selected === memberTypeStep"
          [country]="userLocation"
          (SSUSuccess)="editable = false; stepper.next()"
          (memberTypeClick)="stepper.next()"></app-member-type>
      </div>
    </mat-step>

    <mat-step [editable]="editable" #memberUpdateStep *ngIf="userLocation !== 'NZ'">
      <ng-template matStepLabel>{{stepperLabels.MEMBER_UPDATE}}</ng-template>
      <div class="step-content">
        <button mat-raised-button class="faq-button" (click)="openFAQDialog()">Help and FAQ's</button>
        <app-member-update
          id="memberUpdateStep"
          (memberUpdateClick)="editable = false;stepper.next()"
          [isActiveStep]="stepper.selected === memberUpdateStep"></app-member-update>
      </div>
    </mat-step>

    <mat-step [editable]="editable" *ngIf="userLocation !== 'NZ'">
      <ng-template matStepLabel>{{stepperLabels.SET_PASSWORD}}</ng-template>
      <div class="step-content">
        <button mat-raised-button class="faq-button" (click)="openFAQDialog()">Help and FAQ's</button>
        <app-set-password id="setPasswordStep" (passwordUpdateClick)="stepper.next()"></app-set-password>
      </div>
    </mat-step>

    <mat-step [editable]="editable">
      <ng-template matStepLabel>{{stepperLabels.CONFIRMATION}}</ng-template>
      <div class="step-content">
        <button mat-raised-button class="faq-button" (click)="openFAQDialog()">Help and FAQ's</button>
        <app-confirmation id="confirmationStep"></app-confirmation>
      </div>
    </mat-step>
  </mat-horizontal-stepper>
</div>
